import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {switchMap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {SaveAccountEntriesUseCase} from '../use-cases/save-account-entries.use-case';
import {
  AccountEntriesAppliedEvent
} from '../../../../../shared/application/events/account/account-entries-applied.event';

@Injectable()
export class EntriesAppliedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly saveEntriesUseCase = inject(SaveAccountEntriesUseCase);

  constructor() {
    this.eventBus.ofType(AccountEntriesAppliedEvent).pipe(
      takeUntilDestroyed(this.destroyRef),
      switchMap(event =>
        event.account.bookingId
          ? this.saveEntriesUseCase.execute(event.account)
          : EMPTY
      )
    ).subscribe();
  }
}
